// Tooltip

'use strict';

watch('[data-bs-toggle*="tooltip"]', e => new Tooltip(e));
